/**
 * Query the status of (browser) API permissions
 *
 * @module
 *
 * @see [Permissions API](https://developer.mozilla.org/docs/Web/API/Permissions_API)
 *
 * @todo
 *
 *   Dictionary: permissions, query, notifications, name, userVisibleOnly, denied
 */
import {navigator} from '@acng/frontend-bounty/dom/window.js';

class Permission {
  static #init() {
    return 'permissions' in navigator && 'query' in navigator.permissions ? navigator.permissions : null;
  }

  static #api = this.#init();

  notifications = {
    /**
     * @returns {Promise<boolean>}
     */
    async denied() {
      if (!Permission.#api) {
        return false;
      }

      try {
        const {state} = await Permission.#api.query({name: 'notifications'});

        return state == 'denied';
      } catch (e) {
        console.warn(e);
        DEBUG: console.debug('permission "notifications" not supported');

        return false;
      }
    },
  };
}

const permission = new Permission();

export {permission};
